import React, { useEffect, useState, useRef } from "react";
import { Radio, notification } from "antd";
import { DropdownInput } from "./DropdownInput";
import { useHistory } from "react-router-dom";
import { isProductTobaccoEligible, refModal } from "../../pages/constant/utils";
import { isEmpty } from "lodash";
import Promotions from "../common/Promotions";
import PromotionsPrice from "../common/PromotionPrice";
import PromotionsQTY from "../common/PromotionQTY";
import { saleBadgeFour } from "../../pages/constant/Constants";

const DetailListVarient = ({
  variant_attribute,
  setValues,
  values,
  selectedVariant,
  setSelectedVariant,
  tempProducts,
  userDetail,
  currency,
  quantityCountObj,
  setQuantityCountObj,
  variantValues,
  product,
  settingData,
  themeSettingData,
  userData,
  variantRectangle,
  variantRadio,
  variantDropdown
}) => {
  const history = useHistory();
  let modalRef = useRef(null);
  const [listProducts, setListProducts] = useState([])
  const licensePath = () => history.push('/profile/my-account')
  const handleIncrement = (id, saleable_qty, back_order_ecom) => {
    setQuantityCountObj((prev) => {
      let temp = (prev?.[id] || 0) + 1;
      if (!back_order_ecom && temp >= saleable_qty) {
        temp = saleable_qty;
      }
      return { ...prev, [id]: temp };
    });
  };

  const handleDecrement = (id) => {
    setQuantityCountObj((prev) => {
      let temp = prev?.[id] - 1;
      if (temp <= 0) {
        delete prev[id]
        return { ...prev };
      }
      return { ...prev, [id]: temp };
    });
  };

  const handleChange = (id, value, saleable_qty) => {
    setQuantityCountObj((prev) => {
      let temp = value;
      if (value >= saleable_qty) {
        temp = value;
      }
      return { ...prev, [id]: temp };
    });
  };

  //start combinations 
  const findCombinationsForList = ({
    data,
    // index = null,
    values,
  }) => {
    delete values[variant_attribute.name]
    const lowerCaseCriteria = Object.entries({
      ...values,
    }).reduce((acc, [key, value]) => {
      acc[key.toLowerCase()] = value.toString().toLowerCase();
      return acc;
    }, {});
    const mergeVariant = [variantRadio, variantValues, variantDropdown,variantRectangle]
    const matchingEntries = Object.entries(lowerCaseCriteria).filter(([key, value]) => {
      return mergeVariant.includes(value);
    });
    const matchingCriteria = Object.fromEntries(matchingEntries);    
    return data.filter((item) => {
      return Object.entries(matchingCriteria).every(([key, value]) => {
        return item.product_variant_attribute.some((attribute) => {
          return (
            attribute.ecom_name.toLowerCase() === key &&
            attribute.value.toString().toLowerCase() === value
          );
        });
      });
    });
  };
  //end combinationsfindCombinationsForList
  useEffect(() => {
    try {
      const availableCombination = findCombinationsForList({ data: tempProducts, values })
      setListProducts(availableCombination)
    }
    catch (error) {
      console.error(error)
    }
  }, [product, values])

  const [clickedListedProduct, setClickedListedProduct] = useState();

  const handleListProductClick = (proId) => {
    // setValues((prev) => ({
    //   ...prev,
    //   [variant_attribute.name]: e.target.value,
    // }));
    setClickedListedProduct(proId)
  }

  const clickedStyle = {
    borderRadius: "5px",
    cursor: "pointer",
    backgroundColor: "var(--Gray-50, #F2F2F2)",
    padding: "5px 10px",
  }

  const clickedCommonStyle = {
    borderBottom: "1px solid #E6E6E6", marginBottom:"10px"
  }

  return (
    <div className="frame-wrapper">
      <div className="div-10" style={{ margin: "5px" }}>
        <div style={{ textAlign: "end", marginBottom: "9px" }}>
          {variant_attribute?.attachment ?
            <a href={variant_attribute.attachment} target="_blank">
              <img src={process.env.PUBLIC_URL + "/media/icons/size_guide_img.png"} style={{ height: "24px", width: "24px" }} alt="" />
              <label
                style={{
                  fontFamily: "Montserrat",
                  fontSize: "18px",
                  fontWeight: "400",
                  lineHeight: "22px",
                  letterSpacing: "0em",
                  textAlign: "left",
                  marginLeft: "8px",
                  cursor: "pointer",
                }}>
                {variant_attribute?.attachment_name}
              </label>
            </a>
            : null
          }
        </div>
        <div className="list-view-detail-page">
        {listProducts.map((tempProduct) => 
            <div 
              className="list-product-item-in-detail-page"
              style={ selectedVariant?.id == tempProduct.id ? { ...clickedStyle, ...clickedCommonStyle } : { ...clickedCommonStyle }} 
              onClick={() => {
                setSelectedVariant(tempProduct)
                handleListProductClick(tempProduct.id)
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <div style={{
                  fontFamily: "Montserrat",
                  fontSize: "14px",
                  fontWeight: "500",
                  lineHeight: "18px",
                  letterSpacing: "0em",
                  textAlign: "left",
                }}
                  className="list-variant-name"
                >
                  <div className="variant-list-name">
                    {tempProduct.ecom_name || tempProduct.name}
                    <Promotions product={tempProduct} classMain={"promotion-quick"} 
                      classText={tempProduct?.selected_unit_price?.promotion?.sale_badge_template === saleBadgeFour ? "promotion-text-quick-four" : "promotion-text-quick"}/> 
                  </div>
                  <span style={{ display: "flex", flexFlow: "wrap", marginTop: "4px" }}>
                    <br />

                    {(themeSettingData?.sku_display_on_product_detail || themeSettingData?.upc_display_on_product_detail) && (
                      <span
                        className="variant-quantity"
                      > 
                        {themeSettingData?.sku_display_on_product_detail && tempProduct?.sku && themeSettingData?.upc_display_on_product_detail && (tempProduct.selected_unit_price?.upc || tempProduct?.upc)
                          ? `${tempProduct.sku}  ${!tempProduct.selected_unit_price?.upc ? "" : `/ ${tempProduct.selected_unit_price?.upc}`}`
                          : themeSettingData?.sku_display_on_product_detail && tempProduct?.sku
                            ? tempProduct.sku
                            : themeSettingData?.upc_display_on_product_detail && (!tempProduct.selected_unit_price?.upc ? "" : tempProduct.selected_unit_price.upc )
                              ? !tempProduct.selected_unit_price?.upc ? "" : tempProduct.selected_unit_price?.upc
                              : ''
                        }
                      </span>
                    )}


                    {(!userDetail?.user &&
                      themeSettingData?.stock_display_for_unsecure_user) ||
                      (userDetail?.user &&
                        themeSettingData?.stock_display_for_secure_user) ? (
                      <>
                        <span
                          style={{
                            color: tempProduct?.back_order_ecom ? "#EFD138" : tempProduct?.saleable_qty <= 0 ? "#FB1100" : "#5F4BB6",
                            background: tempProduct?.back_order_ecom ? "#FDFAEB" : tempProduct?.saleable_qty <= 0 ? "#FFE7E5" : "#EFEDF8",
                            marginRight:"3px"
                          }}
                          className="variant-list-qty"
                        >
                          {tempProduct?.back_order_ecom
                            ? "Low Stock"
                            : tempProduct?.saleable_qty <= 0
                              ? "Out of Stock"
                              : `Qty: ${tempProduct?.saleable_qty || 0}`}
                        </span>
                      </>
                    ) : null}
                    {(tempProduct?.certificate_of_analysis) && (
                      <p className="coa-style"
                      style={{fontSize:"14px", fontWeight:"400"}}
                        onClick={() => {
                          const url = tempProduct.certificate_of_analysis
                          if (url) {
                            window.open(url, '_blank');
                          } else {
                            console.error('Certificate of Analysis not available.');
                          }
                        }}
                      >
                        Specs & COA
                      </p>
                    )}
                  </span>
                  
                </div>
                <div>
                    <DropdownInput
                      incrementMainclass={"increment-detail-page"}
                      incrementSubClass={"increment-class-detail-page"}
                      inputCardClass={"new-input-card-detail"}
                      decrement={() => handleDecrement(tempProduct.id)}
                      increment={() => {
                        if (
                          isProductTobaccoEligible(tempProduct, userData, settingData)
                        ) {
                          handleIncrement(
                            tempProduct.id,
                            tempProduct?.saleable_qty ??
                            (tempProduct?.saleable_qty || 0),
                            tempProduct?.back_order_ecom
                          );
                        } else {
                          refModal(modalRef,licensePath);
                        }
                      }}
                      value={quantityCountObj?.[tempProduct?.id] || 0}
                      handleChange={({ target: { value } }) => {
                        const _saleable =
                          tempProduct?.saleable_qty ??
                          (tempProduct?.saleable_qty || 0);
                        const formattedValue = value.replace(/\D/g, "");
                        if (
                          !tempProduct.back_order_ecom &&
                          Number(formattedValue) > _saleable
                        ) {
                          notification.error({
                            message:
                              "You can not add more than in stock quantity",
                          });
                          return;
                        }
                        handleChange(tempProduct.id, formattedValue, _saleable);
                      }}
                    />
                    <PromotionsQTY selectedVariant={tempProduct} />
                  </div>
                <div className="price-quantity-flex">
                <div>
                    {(!userDetail?.user &&
                      themeSettingData?.price_display_for_unsecure_user) ||
                      (userDetail?.user &&
                        themeSettingData?.price_display_for_secure_user) ? (
                      <b>
                        <span className="variant-list-price">
                          <PromotionsPrice product={tempProduct} regularprice={true} currency={currency.currency_symbol}/>
                          {tempProduct?.is_tax_inclusive &&
                            <p className="tax-inclusive">Tax Inclusive</p>
                          }
                        </span>
                      </b>
                    ) : null}
                  </div>
                  
                  
                </div>
              </div>
              <table
                width={"100%"}
                style={{
                  padding: "10px",
                }}
              >
                <tr style={{ display: "flex" }}>
                  {tempProduct.product_variant_attribute?.length > 0 &&
                    tempProduct.product_variant_attribute?.map((variant) => (
                      variant?.display_type == 5 && 
                      <td style={{ width: "100%" }}>
                        <label className="list-view-detail-page-lable">
                          {variant?.ecom_name}:
                        </label>{" "}
                        {/* <br /> */}
                        {variant?.value}
                      </td>
                    ))}
                    <td>
                    <div className="price-quantity-flex-mobile">
                <div>
                    {(!userDetail?.user &&
                      themeSettingData?.price_display_for_unsecure_user) ||
                      (userDetail?.user &&
                        themeSettingData?.price_display_for_secure_user) ? (
                      <b>
                        <span className="variant-list-price">
                          <PromotionsPrice product={tempProduct} regularprice={true} currency={currency.currency_symbol}/>
                        </span>
                      </b>
                    ) : null}
                  </div>
                  
                  
                </div>
                    </td>
                    
                </tr>
              </table>
              {/* <div
                width={"100%"}
                style={{
                  // display: "flex",
                  // justifyContent: "space-between",
                  padding: "10px",
                  paddingTop:"5px"
                }}
              >
                <>
                <label style={{marginRight:"30px", color:"#ea1e51", fontSize:"16px"}}>{variant_attribute.name}{":"}</label>
                {tempProduct?.product_variant_attribute?.length > 0 &&
                    tempProduct?.product_variant_attribute?.find((variant) => (
                          variant?.ecom_name == variant_attribute?.name
                    ))?.value
                    }
                </>
              </div> */}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default DetailListVarient;
